import { THEME } from '@enmon/commons';
import styled from 'styled-components';

export interface CardHighlightProps {
  positive?: boolean;
  negative?: boolean;
}

/*
  USED JUST TO HIGHLIGH NUMBERS OR ICONS
*/
export const CardHighlight = styled.div<CardHighlightProps>`
  font-size: 2.6rem;
  ${props => props.positive && `color: ${THEME.color.theme.primary};`}
  ${props => props.negative && `color: ${THEME.color.status.error};`}
`;
